import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const StyledChipWrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0.5),
  boxShadow: 'none'
}));

export default StyledChipWrapper;
